import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ViewsProps extends Vue {
  @Prop({ type: Boolean, default: true })
  readonly isLoading!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isError!: boolean;

  @Prop({ type: Array, default: () => [] })
  readonly data!: Array<any>;
}



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/mixins/viewsProps.ts